import React from "react";
import BaseDefault from "../../core/BaseDefault";

export default function Other_Page(){
    return(
        <BaseDefault
            styles="Other"
            title="Others"    
        >
        
        </BaseDefault>
    )
}